import React, { cloneElement } from 'react'

import { TableBody } from '@material-ui/core'
import classnames from 'classnames'

export const CustomDatagridBody = React.forwardRef(
  (
    {
      basePath,
      children,
      classes,
      className,
      data,
      expand,
      hasBulkActions,
      hover,
      ids,
      onToggleItem,
      resource,
      row,
      rowClick,
      rowStyle,
      selectedIds,
      isRowSelectable,
      currentSort,
      defaultTitle,
      displayedFilters,
      filterValues,
      hasCreate,
      hideFilter,
      loading,
      loaded,
      onUnselectItems,
      perPage,
      setFilters,
      setPerPage,
      setPage,
      setSort,
      showFilter,
      totalPages,
      exporter,
      hasList,
      hasEdit,
      hasShow,
      ...rest
    },
    ref
  ) => {
    return (
      <TableBody
        ref={ref}
        className={classnames('datagrid-body', className)}
        {...rest}
      >
        {ids.map((id, rowIndex) =>
          cloneElement(
            row,
            {
              basePath,
              classes,
              className: classnames(classes.row, {
                [classes.rowEven]: !(rowIndex % 2),
                [classes.rowOdd]: rowIndex % 2 !== 0,
                [classes.clickableRow]: rowClick,
              }),
              expand,
              hasBulkActions,
              hover,
              id,
              key: id,
              onToggleItem,
              record: data[id],
              resource,
              rowClick,
              selectable: !isRowSelectable || isRowSelectable(data[id]),
              selected: selectedIds.includes(id),
              style: rowStyle ? rowStyle(data[id], rowIndex) : null,
            },
            children
          )
        )}
      </TableBody>
    )
  }
)
